'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _content = require('../content/content');

var _content2 = _interopRequireDefault(_content);

var _showbagContents = require('./showbag-contents');

var _showbagContents2 = _interopRequireDefault(_showbagContents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @class Showbag
  * This component displays content that visitors
  * have added to a personal "showbag".  It also
  * adds methods to a global `vexpo.showbag` object:
  * `vexpo.showbag.add(content)` adds a new content item
  * to the showbag.  Returns a promise.
  * `vexpo.showbag.remove(content)` similarily removes
  * the specified content from the showbag.  Returns a
  * promise.
  * `vexpo.showbag.includes(content)` returns true if the
  * content exists in the showbag, or false otherwise
  * `vexpo.showbag.show()` displays the showbag.
  * @prop {URLString} background - an (optional) image to display
  * behind the showbag contents.
  * @prop {Array} initialContents - an (optional) array of contents
  * to preload into visitor's bags.
  */
var Showbag = function (_Component) {
  _inherits(Showbag, _Component);

  /** @constructor
    * Constructs a new showbag, customized to the
    * current user (as defined by firebase auth).
    */
  function Showbag(props) {
    _classCallCheck(this, Showbag);

    var _this = _possibleConstructorReturn(this, (Showbag.__proto__ || Object.getPrototypeOf(Showbag)).call(this, props));

    _this.state = {
      visible: true,
      contents: []
    };
    _this.add = _this.add.bind(_this);
    _this.remove = _this.remove.bind(_this);
    _this.includes = _this.includes.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.exit = _this.exit.bind(_this);
    return _this;
  }
  /** @method componentWillMount
    * Links the component with the user's showbag
    * data in the database and sets up the
    * `vepo.showbag` functions.
    */


  _createClass(Showbag, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      // Add showbag functions to the vexpo object
      if (!window.vexpo) window.vexpo = {};
      if (!window.vexpo.showbag) window.vexpo.showbag = {};
      window.vexpo.showbag.add = this.add;
      window.vexpo.showbag.remove = this.remove;
      window.vexpo.showbag.includes = this.includes;
      // Bind showbag to firebase user entry (if exists)
      if (window.vexpo.firebase && window.vexpo.firebase.auth().currentUser) {
        // cache changes in user's firebase realtime database entry
        var uid = window.vexpo.firebase.auth().currentUser.uid;
        this.firebaseRef = window.vexpo.firebase.database().ref('showbags/' + uid + '/' + this.props.expoID + '/' + this.props.showID + '/');
        this.firebaseRef.on('value', function (snapshot) {
          var contents = snapshot.val();
          // if the bag is empty, preload it with the initialContents
          if (!contents) {
            contents = _this2.props.initialContents || [];
          }
          _this2.setState({ contents: contents });
        });
      } else {
        // user's showbag contents are not cached beyond this session.
        // preload with initialContents
        var contents = this.props.initialContents || [];
        this.setState({ contents: contents });
      }
    }
    /** @method componentWillUnmount
      * Removes the database listener.
      */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.firebaseRef) this.firebaseRef.off();
    }
    /** @method add
      * Adds the provided content to the showbag.
      * @prop {Object} content - the content to add.
      * @returns {Promise} a promise to add the content.
      */

  }, {
    key: 'add',
    value: function add(content) {
      var _this3 = this;

      var contents = this.state.contents;
      contents.unshift(content);
      if (this.firebaseRef) return this.firebaseRef.set(contents);else return new Promise(function (fulfil) {
        _this3.setState({ contents: contents }, fulfil());
      });
    }
    /** @method remove
      * Removes the provided content from the showbag.
      * @prop {Object} content - the content to remove.
      * @returns {Promise} a promise to remove the content.
      */

  }, {
    key: 'remove',
    value: function remove(content) {
      var _this4 = this;

      var contents = this.state.contents;
      var index = contents.findIndex(function (c) {
        return c.id === content.id;
      });
      if (index !== -1) contents.splice(index, 1);
      if (this.firebaseRef) return this.firebaseRef.set(contents);else return new Promise(function (fulfil) {
        _this4.setState({ contents: contents }, fulfil());
      });
    }
    /** @method includes
      * Tells if the specified content is already in the showbag.
      * @prop {Object} content - the content to check.
      * @returns {bool} true if the content is in the showbag, false if not.
      */

  }, {
    key: 'includes',
    value: function includes(content) {
      var contents = this.state.contents;
      var index = contents.findIndex(function (c) {
        return c.id === content.id;
      });
      return index !== -1;
    }
    /** @method show
      * Displays the showbag.
      */

  }, {
    key: 'show',
    value: function show() {
      this.setState({ visible: true });
    }
    /** @method exit
      * Hides the showbag
      */

  }, {
    key: 'exit',
    value: function exit() {
      this.setState({ visible: false });
    }
    /** @method render
      * Renders the showbag using Masonry.js
      */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_showbagContents2.default, { background: this.props.background, contents: this.state.contents });
    }
  }]);

  return Showbag;
}(_react.Component);

exports.default = Showbag;


Showbag.propTypes = {
  initialContents: _propTypes2.default.array,
  background: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/showbag/showbag.js
// module id = 244
// module chunks = 0